import { createIcon } from '../shared'

const DotsIcon = createIcon(
  ({ color }) => (
    <g fill={color}>
      <circle cx="5" cy="12" r="1.75" />
      <circle cx="12" cy="12" r="1.75" />
      <circle cx="19" cy="12" r="1.75" />
    </g>
  ),
  '0 0 24 24',
  'DotsIcon',
)

export { DotsIcon }
